import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
      height: '64px',
      padding: '10px 20px 10px 20px',
      borderRadius: '15px 15px 0 0',
      background: palette.background.box,
      boxShadow: palette.shadows.boxShadow,
      '& a': {
        padding: '0'
      }
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
